// localStorage key used to persist the logged-in user's profile + raw menu
// data so the session can be rehydrated after a browser refresh.
export const AUTH_STORAGE_KEY = "fintrack_user";
